import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { CheckableButton } from '@dealstack/frontend/shared/components/CheckableButton/CheckableButton';
import { Menu, MenuDropdownProps, Text, TextProps } from '@mantine/core';
import styled from 'styled-components';
import { MouseEventHandler, ReactNode, type ComponentProps } from 'react';
import { asPlainComponent } from '@dealstack/frontend/shared/utils/asPlainComponent';

const PlainText = asPlainComponent<ComponentProps<typeof Text>>(Text);

export const TagsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	padding: 0.5rem;
`;

export const Tags = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 0.25rem;
	max-width: 24rem;
`;

export const InputWrapper = styled.div`
	.mantine-Input-input {
		margin: 0;
	}
`;

export const EntityButton = styled(CheckableButton)`
	width: 100%;
	display: flex;
	justify-content: flex-start;
	min-width: min-content;
`;

export const VirtualListContainer = styled.div`
	min-height: 0.125rem;
	max-height: 24rem;
	width: 100%;
	min-width: 16rem;
	overflow-y: auto;
`;

export const VirtualListItem = styled.div`
	padding: 0.125rem 0;
	overflow: hidden;
`;

export const TagContentDiv = styled.div`
	display: flex;
	align-items: center;
	flex-direction: row;
`;

export const CloseIconButton = styled(Icon)`
	margin-left: 0.25rem;
	cursor: pointer;
`;

interface AddNewTextProps extends TextProps {
	onClick?: MouseEventHandler<HTMLDivElement>;
	children?: ReactNode;
	disabled?: boolean;
}

export const AddNewText = styled(PlainText)<AddNewTextProps>`
	cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
	user-select: none;
	opacity: ${(props) => (props.disabled ? 0.3 : 1)};
	pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
`;

export const TagItemDiv = styled.div`
	width: 100%;
	padding: 0.25rem;
`;

interface VirtualListWrapperProps {
	$totalHeight: number;
}

export const VirtualListWrapper = styled.div<VirtualListWrapperProps>`
	height: ${(props) => `${props.$totalHeight}px`};
	position: relative;
	width: 100%;
`;

export const NoResultsDiv = styled.div`
	padding: 0.25rem;
`;

export const TagsDropdownContainer = styled.div`
	min-width: 9rem;
`;

export const UserSelectionText = styled(PlainText)<TextProps>`
	user-select: none;
`;

export const EntitySelectorMenuDropdown = styled(Menu.Dropdown)<MenuDropdownProps>`
	border: none;
	border-radius: 0.5rem;
	${({ theme }) => theme.shadow.z1}
`;

export const PersonDropdownContainer = styled.div`
	width: 24rem;
`;
